module["exports"] = ["ჯგუფი", "და კომპანია", "სტუდია", "გრუპი"];